module.exports = __webpack_public_path__ + "img/apple_playstore_black.c7904197.svg";